(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbso-footer"] && !Shopify.designMode) return;
  try {
    
  const footerDesktopQuery = window.matchMedia('(min-width: 750px)');

  const syncFooterMenus = () => {
    document.querySelectorAll('.tbso-footer__menu').forEach((menu) => {
      const nextMode = footerDesktopQuery.matches ? 'desktop' : 'mobile';

      if (nextMode === 'desktop') {
        menu.open = true;
      } else if (menu.dataset.footerMode !== 'mobile') {
        menu.open = false;
      }

      menu.dataset.footerMode = nextMode;
    });
  };

  syncFooterMenus();
  footerDesktopQuery.addEventListener('change', syncFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbso-newsletter-popup"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tbso-newsletter-popup]');
    if (!root) return;
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const subscriberKey = 'tbsoNewsletterPopupSubscribed';
    const sessionDismissedKey = 'tbsoNewsletterPopupDismissedThisSession';
    const delay = Number(root.dataset.delay || 5000);
    const isDesignMode = root.dataset.designMode === 'true';
    const customerSubscribed = root.dataset.customerSubscribed === 'true';
    const success = root.querySelector('[data-newsletter-success]') !== null;
    let storedSubscriber = false;
    let dismissedThisSession = false;
    try {
      localStorage.removeItem('tbsoNewsletterPopupDismissed');
      if (success) localStorage.setItem(subscriberKey, 'true');
      storedSubscriber = localStorage.getItem(subscriberKey) === 'true';
      dismissedThisSession = sessionStorage.getItem(sessionDismissedKey) === 'true';
    } catch (error) {
      storedSubscriber = success;
    }
    if (!isDesignMode && !success && (customerSubscribed || storedSubscriber || dismissedThisSession)) return;
    const openDialog = () => { if (!dialog.open) dialog.showModal(); };
    const timer = window.setTimeout(openDialog, isDesignMode || success ? 150 : delay);
    root.querySelectorAll('[data-newsletter-close]').forEach((button) => button.addEventListener('click', () => {
      try {
        sessionStorage.setItem(sessionDismissedKey, 'true');
      } catch (error) {
        // The dialog can still close when storage is unavailable.
      }
      dialog.close();
    }));
    dialog.addEventListener('close', () => {
      window.clearTimeout(timer);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
